module cr.events {
    class EventController {
        static $inject = ['eventView', 'TrackingService', '$scope', '$stateParams','$modal','$state' ];

        Search(toSearch:string) {
            console.log("ok, search registration for: "+toSearch);

            this.trackingService.searchRegistration(this.$stateParams['eventId'],toSearch).then(data=>{
                this.$scope.searchResult=data;
                console.log("search result: "+data);
            });
        }

        constructor(private eventView, private trackingService, private $scope, private $stateParams, private $modal,$state) {

            $scope.eventView=eventView;
            $scope.context="chronorace";

            $scope.searchResult={ rows:[] };

            $scope.Search=(value)=>this.Search(value);

            $scope.RowAction=(action,data)=>{
                console.log("Row Action: "+action+" "+angular.toJson(data));
            }

            $scope.Select=(data)=>{
                console.log("we select: "+angular.toJson(data));
                //$state.go("^.results.my",{bib: data.Bib });
            }

        }
    }

    eventModule
        .controller('EventController', EventController);

}
